export default {
  artisans: 'artisans',
  devis: 'devis',
  interventions: 'interventions',
  login: 'login',
  users: 'users',
  signature: 'signature',
  campagnes: 'campagnes',
  paiements: 'paiements',
  propositions: 'propositions',
  metiersDevis: 'metiersDevis',
  count: 'count'
};
